import Button from "@components/core/Button";
import classNames from "classnames";

function LikeButton({ liked, onClick, className }) {
  return (
    <Button
      trackingName={liked ? "HeartRemoveFromWishlist" : "HeartAddToWishlist"}
      variant={liked ? "primary" : "outline-primary"}
      size="xs"
      leftIconName="heart-empty"
      onClick={onClick}
      className={classNames("rounded-circle border-none", className)}
    />
  );
}

export default LikeButton;
